import {
  Box,
  Button,
  Card,
  Step,
  StepLabel,
  Stepper,
  Typography,
} from "@mui/material";
import { FC, ReactNode, useState } from "react";

type StepsLayoutContainerProps = {
  steps: string[];
  StepComponentList: ReactNode[];
  onStepChange?: (step: number) => void;
  onComplete?: () => void;
};

export const StepsLayoutContainer: FC<StepsLayoutContainerProps> = ({
  steps,
  StepComponentList,
  onStepChange,
  onComplete,
}) => {
  const [activeStep, setActiveStep] = useState(0);

  const handleNext = () => {
    if (activeStep + 1 < steps.length) {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
      if (onStepChange) {
        onStepChange(activeStep + 1);
      }
    } else {
      if (onComplete) {
        onComplete();
      }
    }
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) =>
      prevActiveStep > 0 ? prevActiveStep - 1 : 0,
    );
  };

  return (
    <Card>
      <Box display="flex" sx={{ minHeight: "calc(100vh - 175px)" }}>
        <Box width="20%" bgcolor="#f5f5f5" p={2}>
          <Stepper activeStep={activeStep} orientation="vertical">
            {steps.map((label, index) => (
              <Step key={label}>
                <StepLabel>
                  <Typography
                    variant="body1"
                    color={index === activeStep ? "primary" : "textSecondary"}
                  >
                    Step {index + 1}: {label}
                  </Typography>
                </StepLabel>
              </Step>
            ))}
          </Stepper>
        </Box>

        <Box flex={1} display="flex" flexDirection="column">
          <Box flex={1} p={4}>
            <Box display="flex" flexDirection="column">
              {StepComponentList.map(
                (StepComponent, index) =>
                  activeStep === index && (
                    <div key={`step_${index}`}>{StepComponent}</div>
                  ),
              )}
            </Box>
          </Box>

          <Box p={4}>
            <Box display="flex" justifyContent="flex-end">
              <Box mr={2}>
                <Button variant="outlined" onClick={handleBack}>
                  Cancel
                </Button>
              </Box>
              <Box>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleNext}
                >
                  {activeStep + 1 < steps.length
                    ? `Continue to Step ${activeStep + 2}`
                    : "Complete"}
                </Button>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Card>
  );
};
